'use client';

import dynamic from 'next/dynamic';

export const ColorfulParticlesDemo = dynamic(
  () => import('./ColorfulParticlesDemo')
);

export const ColorBricksArray = dynamic(
  () => import('./ColorBricksArray')
);

export const HueVsHueRotateDemo = dynamic(
  () => import('./HueVsHueRotateDemo')
);

export const HueRotateDemo = dynamic(() => import('./HueRotateDemo'));

export const TwinklingDemo = dynamic(() => import('./TwinklingDemo'));

export const FinalParticleButton = dynamic(
  () => import('./FinalParticleButton')
);
